"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsBulkDiscount = exports.getProductIsolatedBulkDiscount = exports.getProductBulkDiscount = void 0;
const _shared_1 = require("../shared");
const product_direct_discount_1 = require("./product-direct-discount");
const discounts_helper_1 = require("./discounts-helper");
const calculateProductBulkDiscount = (product, discountedProduct) => {
    var _a, _b;
    const bulkDiscountMinOrderQuantity = (_a = product.productBulkDiscount) === null || _a === void 0 ? void 0 : _a.productBulkDiscountMinOrderQuantity;
    const bulkDiscountPercentage = (_b = product.productBulkDiscount) === null || _b === void 0 ? void 0 : _b.productBulkDiscountPercentage;
    // check if the product has a bulk discount and if the quantity is greater or equal to the min order quantity
    const discountPercentageToApply = (bulkDiscountMinOrderQuantity && bulkDiscountPercentage && product.quantity >= bulkDiscountMinOrderQuantity) ? bulkDiscountPercentage : 0;
    const lineItemSubtotal = discountedProduct.lineItemSubtotal;
    const discountAmount = lineItemSubtotal * (0, _shared_1.convertDBToRate)(discountPercentageToApply);
    const discountedTotal = lineItemSubtotal - discountAmount;
    return Object.assign(Object.assign({}, discountedProduct), { subtotal: discountedTotal, total: discountedTotal, discounts: Object.assign(Object.assign({}, discountedProduct.discounts), { bulk: {
                subtotal: lineItemSubtotal,
                discountAmount,
                total: discountedTotal
            } }) });
};
/**
 * Calculates a single product bulk discount (e.g: *Buy 10 units get 10% off*).
 * Only applies the bulk discount if the minimum order quantity is greater or equal to the bulk discount min order quantity.
 *
 * Important: Applies the direct discount before calculating the bulk discount.
 */
const getProductBulkDiscount = (product) => {
    // console.log('product: ', product);
    // Apply direct discount first
    const discountedProduct = (0, product_direct_discount_1.getProductDirectDiscount)(product);
    // console.log('discountedProduct: ', discountedProduct);
    // Apply bulk discount
    return calculateProductBulkDiscount(product, discountedProduct);
};
exports.getProductBulkDiscount = getProductBulkDiscount;
/**
 * Calculates a single product bulk discount (e.g: *Buy 10 units get 10% off*) without considering the direct discount.
 * Only applies the bulk discount if the minimum order quantity is greater or equal to the bulk discount min order quantity.
 */
const getProductIsolatedBulkDiscount = (product, lineItemSubtotal) => {
    const discountedProduct = (0, discounts_helper_1.buildEmptyDiscountedProduct)(product.productId);
    discountedProduct.lineItemSubtotal = lineItemSubtotal;
    return calculateProductBulkDiscount(product, discountedProduct);
};
exports.getProductIsolatedBulkDiscount = getProductIsolatedBulkDiscount;
/**
 * Calculates a list of products bulk discount. See the `getProductBulkDiscount`
 * method description for more details.
 */
const getProductsBulkDiscount = (products) => products.reduce((acc, product) => {
    const discountedProduct = (0, exports.getProductBulkDiscount)(product);
    return (0, discounts_helper_1.buildProductsDiscountSummary)(acc, discountedProduct);
}, { products: [], lineItemSubtotal: 0, subtotal: 0, total: 0, discounts: { direct: 0, bulk: 0, store: 0 } });
exports.getProductsBulkDiscount = getProductsBulkDiscount;
